<template>
  <div>
    <v-row cols="12" sm="12" md="12" lg="12" class="row-menu-right mb-3 pr-3" style="margin-top: -50px;">
      <v-btn
        v-if="mode=='approve'"
        outlined
        class="button-color-outline head-search-button mr-1"
        :disabled="!allowBtnReject"
        @click="clickReject()"
      >
      {{ textBtnNO }}
      </v-btn>
      <v-btn
        class="button-color head-search-button ml-1 white--text text--lighten-4"
        elevation="0"
        :disabled="!allowBtnApprove"
        @click="clickApprove()"
      >
      {{ textBtnOk }}
      </v-btn>
    </v-row>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        class="border-table-employee text-no-wrap table-approve"
        item-key="_id"
        v-model="selected"
        :headers="headers"
        :items="dataSource"
        :loading="loading"
        loader-height=0
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        :single-select="singleSelect"
        :show-select="true"
        @input="checkAllowBtn()"
        @toggle-select-all="selectAllToggle"
        disable-sort
        :page.sync="page"
        :items-per-page="perPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
          <v-checkbox
            v-if="(item.requestStatusTH === 'รออนุมัติ' || item.requestStatusTH === 'รอรับทราบ')
            || (item.requestStatusTH === 'กำลังดำเนินการ')"
            v-show="true"
            v-model="item.selected"
            :value="isSelected"
            hide-details
            class="ma-0"
            style="width: 0px;"
            color="gray"
            @change="select($event)"
          />
        </template>
        <template v-slot:[`item.no`]="{ item }">
          {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="statusList.filter(e => e.statusTH === item.requestStatusTH)[0].colorback"
            :text-color="statusList.filter(e => e.statusTH === item.requestStatusTH)[0].color"
          >
            <span>{{ item.requestStatusTH || '-' }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                icon
                tile
                class="ra-border-button mr-2"
                @click="view(item)"
              >
              <v-icon dark class="icon-eye-color">mdi-account-multiple-check</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">view</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-row>
      <v-col cols="12" class="pa-0">
      <div class="justify-end d-flex align-end pt-4">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </div>
      </v-col>
    </v-row>
    </div>
    <DialogShowDetail/>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="344"
      max-height="232"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          <span style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #2BA197;">
            {{ mode=='approve'? workfor=='approve'? 'ต้องการอนุมัติคำร้องใช่ไหม':'ต้องการไม่อนุมัติคำร้องใช่ไหม':'ต้องการรับทราบคำร้องใช่ไหม' }}
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;">
            {{ mode=='approve'? workfor=='approve'? 'คุณแน่ใจหรือไม่ว่าต้องการอนุมัติคำร้อง':'คุณแน่ใจหรือไม่ว่าไม่ต้องการอนุมัติคำร้อง':'คุญแน่ใจหรือไม่ว่าต้องการรับทราบคำร้อง' }}
          </span>
        </v-card-subtitle>
        <v-textarea v-model="comment" class="ml-8 mr-8" outlined rows="2" placeholder="ระบุความเห็น" v-if="mode=='approve'" @keydown.space.prevent @keydown.enter="$event.preventDefault()"></v-textarea>
        <v-card-actions class="justify-center pb-4">
          <v-btn class="button-color-outline pl-5 pr-5 mr-3" style="border-radius: 6px;" outlined @click="dialog = false">ยกเลิก</v-btn>
          <v-btn class="button-color pl-5 pr-5" style="border-radius: 6px;" dark @click="updateStatusApprove(workfor, mode, comment)">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      top
      centered
      elevation="1"
      color="#ECF8EA"
      app
    >
      <v-icon dark color="#58A144" >mdi-check-circle-outline</v-icon>
      <span style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #58A144;">
        {{ workfor=='approve'? 'คุณได้ทำการอนุมัติคำร้องเรียบร้อย':'คุณได้ทำการไม่อนุมัติคำร้องเรียบร้อย' }}
      </span>
    </v-snackbar>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import DialogShowDetail from '../_dialog/dialogShowDetail'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import { fetchAllRequestApproveEmployee } from '@/API/API'
const swal = require('sweetalert')
const axios = require('axios')
const moment = require('moment')
export default {
  name: 'tree',
  components: {
    OverlayLoading,
    DialogShowDetail
  },
  props: {
    mode: String
  },
  data () {
    return {
      dialog: false,
      workfor: 'approve',
      comment: '',
      snackbar: false,
      isAdmin: this.$store.state.user.role ? (this.$store.state.user.role).includes('administrator') : false,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      loading: false,
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 15,
        page: 1
      },
      textBtnOk: this.mode === 'approve' ? 'อนุมัติ' : 'รับทราบ',
      textBtnNO: this.mode === 'approve' ? 'ไม่อนุมัติ' : 'ไม่รับทราบ',
      statusList: [
        { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF', colorback: '#ECF9FF' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144', colorback: '#ECF8EA' },
        { status: 'waiting', statusTH: 'รออนุมัติ', color: '#E9A016', colorback: '#FEF5E9' },
        { status: 'waiting', statusTH: 'รอรับทราบ', color: '#E9A016', colorback: '#FEF5E9' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B', colorback: '#FBE5E4' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#D1392B', colorback: '#FBE5E4' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144', colorback: '#ECF8EA' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'left fixed',
          value: 'no',
          width: '70px',
          groupable: false,
          sortable: false,
          class: 'column-fix'
        },
        { text: 'หมายเลขคำร้อง', value: 'reqEmployeeNo', divider: true, align: 'left fixed', class: 'column-fix' },
        { text: 'ชื่อ-นามสกุล', value: 'employeeName' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'บริษัท', value: 'companyName' },
        { text: 'ประเภทคำร้อง', value: 'requestTypeTH' },
        { text: 'สถานะคำร้อง', value: 'status', width: '15%' },
        { text: '', align: 'right', width: '5%', value: 'actions', sortable: false }
      ],
      selected: [],
      dataSource: [],
      serviceTypeList: [],
      requestStatusList: [],
      total: -1,
      perPage: 15,
      pageCount: 0,
      page: 1,
      textCondition: {
        new: 'เพิ่มบุคคล',
        transfer: 'ขอย้ายฝ่าย',
        resign: 'ขอลาออก',
        transferPosition: 'ย้ายตำแหน่ง',
        resignPosition: 'ลาออกจากตำแหน่ง',
        resignEmployee: 'ลาออกจากบริษัท'
      },
      approveRole: localStorage.manageapproveRole === 'Admin' ? 'Admin' : 'Leader'
    }
  },
  async created () {
    // await this.searchFilterData(this.filterData)
    this.loading = true
  },
  beforeDestroy () {
    EventBus.$off('openDialogManageApprove')
    EventBus.$off('manageApproveSearch')
    this.loading = false
  },
  mounted () {
    EventBus.$on('manageApproveSearch', this.setFilter)
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    async setFilter (value) {
      if (this.filterData.role) this.approveRole = this.filterData.role
      this.filterData = value
      var searchPayload = {
        companyName: this.filterData.companyName || [],
        groupCompanyName: this.filterData.groupCompanyName || [],
        position: this.filterData.position || [],
        reqEmployeeNo: this.filterData.reqEmployeeNo || '',
        requestType: this.filterData.requestType || [],
        role: this.filterData.role,
        searchNameAndEmpId: this.filterData.searchNameAndEmpId || '',
        status: this.filterData.status || [''],
        tab: this.filterData.tab,
        limit: this.perPage,
        page: this.page
      }
      this.searchFilterData(searchPayload)
    },
    async searchFilterData (value) {
      const self = this
      self.loading = true
      self.selected = []
      self.filterData = value
      try {
        const res = await fetchAllRequestApproveEmployee(value, this.$store.state.token)
        if (res.success) {
          // console.log('ข้อมูลได้ตาราง', res)
          EventBus.$emit('updateTotal', {
            totalAll: res.totalAll,
            totalApproved: res.totalApproved,
            totalPending: res.totalPending,
            totalRejected: res.totalRejected,
            totalWaiting: res.totalWaiting
          })
          self.total = res.total || -1
          self.dataSource = res.result || []
          self.computeData(self.dataSource)
        } else {
          self.dataSource = []
        }
      } catch (error) {
        console.log(error)
        self.dataSource = []
      } finally {
        self.loading = false
      }
    },
    async computeData (item) {
      await item.map(e => {
        e.updateAt = moment(e.updateAt).format('DD/MM/YYYY HH:mm น.')
      })
    },
    // async updateAcknowledge (listId) {
    //   var obj = {
    //     acknowledgeList: listId
    //   }
    //   // console.log(obj)
    // },
    view (item) {
      // console.log(item)
      EventBus.$emit('openDialogManageApprove', this.filterData.role, item)
    },
    createRequestService () {
      // console.log('createRequestService')
      // this.$router.push('/authorityservices/requestservicelist/create')
      this.$router.push('/authorityservices/myservicelist/create')
    },
    checkAllowBtn () {
      if (this.selected.length > 0) {
        this.allowBtnApprove = true
        this.allowBtnReject = true
      } else {
        this.allowBtnApprove = false
        this.allowBtnReject = false
      }
    },
    clickApprove () {
      this.comment = ''
      this.dialog = true
      this.workfor = this.mode === 'approve' ? 'approve' : 'acknowledge'
    },
    clickReject () {
      this.comment = ''
      this.dialog = true
      this.workfor = 'reject'
    },
    async updateStatusApprove (task, mode, comment) {
      const self = this
      var confirmList = []
      self.selected.forEach(e => {
        confirmList.push(
          {
            requestStatus: task,
            comment: comment,
            role: mode === 'acknowledge' ? 'Leader' : this.filterData.role,
            _id: e._id
          }
        )
      })
      await axios({
        url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/manageEmployee/updateStatusReqEmployee`,
        method: 'POST',
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          approveList: confirmList
        }
      })
        .then((response) => {
          if (response.data.success === true) {
            // swal('สำเร็จ', 'ทำรายการเรียบร้อย', 'success', {
            //   button: false,
            //   timer: 2000
            // })
            this.dialog = false
            this.snackbar = true
            this.page = 1
            self.searchFilterData(self.filterData)
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        })
        .catch(function (thrown) {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        })
    },
    select (event) {
      this.checkAllowBtn()
    },
    selectAllToggle (props) {
      if (this.selected.length === 0) {
        this.selected = []
        const self = this
        props.items.forEach(item => {
          if ((item.requestStatusTH === 'รออนุมัติ' || item.requestStatusTH === 'รอรับทราบ') || (item.requestStatusTH === 'กำลังดำเนินการ')) {
            const mapitem = { ...item, selected: true }
            self.selected.push(mapitem)
          }
        })
      } else this.selected = []
    }
  }
}
</script>

<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>

<style scoped>

.table-approve >>> table > tbody > tr > td:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(1) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 0;
}

.table-approve >>> table > tbody > tr > td:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(2) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 56px;
}

.table-approve >>> table > tbody > tr > td:nth-child(3),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  position: sticky;
  position: -webkit-sticky;
  background: white;
  left: 126px;
}

.table-approve >>> table > tbody > tr:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr:hover > td:nth-child(3) {
  background: #eeeeee;
}

.table-approve >>> table > thead > tr > th:nth-child(1),
.table-approve >>> table > thead > tr > th:nth-child(2),
.table-approve >>> table > thead > tr > th:nth-child(3) {
  background-color: #F8F9FB;
}

.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected > td:nth-child(3) {
  background: #f7f7f7;
}

.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(1),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(2),
.table-approve >>> table > tbody > tr.v-data-table__selected:hover > td:nth-child(3) {
  background: #eeeeee;
}
</style>
